
import { GlobalController } from 'src/shared/global/GlobalController'
import TruckWeightCapacity from './TruckWeightCapacity'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'truckWeightCapacity',
    component: TruckWeightCapacity,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
